import { render, staticRenderFns } from "./CourseDashboardCard.vue?vue&type=template&id=c6cdf222&scoped=true&"
import script from "./CourseDashboardCard.vue?vue&type=script&lang=js&"
export * from "./CourseDashboardCard.vue?vue&type=script&lang=js&"
import style0 from "./CourseDashboardCard.vue?vue&type=style&index=0&id=c6cdf222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6cdf222",
  null
  
)

export default component.exports